import { render } from "./RaceTypeEditView.vue?vue&type=template&id=2a9f228c&scoped=true"
import script from "./RaceTypeEditView.vue?vue&type=script&lang=js"
export * from "./RaceTypeEditView.vue?vue&type=script&lang=js"

import "./RaceTypeEditView.vue?vue&type=style&index=0&id=2a9f228c&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9f228c"]])

export default __exports__